import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Product } from '@planone/bau365/util-fair-data';
import { CookieConsentFacade } from '@planone/shared/feature-cookie-consent';
import { Observable } from 'rxjs';

@Component({
  selector: 'bau365-product-section-media',
  templateUrl: './section-media.component.html',
  styleUrls: ['./section-media.component.scss'],
})
export class SectionProductMediaComponent {
  @Input() product?: Product;

  @Output() tabChange: EventEmitter<MatTabChangeEvent> = new EventEmitter<MatTabChangeEvent>();
  @Output() download: EventEmitter<{ element: EventTarget | null; fileName: string }> = new EventEmitter<{
    element: EventTarget | null;
    fileName: string;
  }>();
  @Output() linkClick: EventEmitter<{
    element: EventTarget | null;
    linkType: string;
    contactPersonId?: string;
    linkText?: string;
  }> = new EventEmitter<{
    element: EventTarget | null;
    linkType: string;
    contactPersonId?: string;
    linkText?: string;
  }>();

  cookieConsent$: Observable<boolean | undefined>;

  constructor(cookieConsentFacade: CookieConsentFacade) {
    this.cookieConsent$ = cookieConsentFacade.accepted$;
  }

  trackTabChange = (event: MatTabChangeEvent) => this.tabChange.emit(event);

  trackDownload = (element: EventTarget | null, fileName: string) => this.download.emit({ element, fileName });

  trackClick = (
    element: EventTarget | null,
    linkType: string,
    contactPersonId: string | undefined = undefined,
    linkText: string | undefined = undefined
  ) => this.linkClick.emit({ element, linkType, contactPersonId, linkText });
}
